import React, { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";

// Plotly's WebGL bundle is ~0.5 MB gzipped, so it is loaded on demand and
// only the pages that show the measured repeatability pay for it.
const RepeatabilityGamutPlotInner = React.lazy(() => import("./RepeatabilityGamutPlotInner"));

/** See RepeatabilityGamutPlotInner for the props and the drawing rules. */
export default function RepeatabilityGamutPlot(props) {
    const height = props.height ?? 520;
    return (
        <Suspense
            fallback={
                <Box sx={{ height, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={28} thickness={4} aria-label="Loading the 3D gamut" />
                </Box>
            }
        >
            <RepeatabilityGamutPlotInner {...props} />
        </Suspense>
    );
}
